import React from 'react';
import { CheckSign } from 'components';
import './ucp-docs.scss';

interface UcpDocsProps {
  docs: React.ReactNode;
  title?: string;
}

const UcpDocs: React.FC<UcpDocsProps> = ({ docs, title }) => (
  <div className="ucp__docs">
    <h3 className="h3">{title || 'Подписываемые документы:'}</h3>
    {docs}
    <CheckSign />
  </div>
);

export default UcpDocs;
